/**
 * Local storage helper utilities
 */

const STORAGE_PREFIX = 'menu-widget-'

/**
 * Save data to localStorage
 */
export function saveToStorage<T>(key: string, data: T): void {
  try {
    const serialized = JSON.stringify(data)
    localStorage.setItem(STORAGE_PREFIX + key, serialized)
  } catch (error) {
    console.error('Error saving to localStorage:', error)
  }
}

/**
 * Load data from localStorage
 */
export function loadFromStorage<T>(key: string): T | null {
  try {
    const serialized = localStorage.getItem(STORAGE_PREFIX + key)
    if (serialized === null) return null
    return JSON.parse(serialized) as T
  } catch (error) {
    console.error('Error loading from localStorage:', error)
    return null
  }
}

/**
 * Remove data from localStorage
 */
export function removeFromStorage(key: string): void {
  try {
    localStorage.removeItem(STORAGE_PREFIX + key)
  } catch (error) {
    console.error('Error removing from localStorage:', error)
  }
}

/**
 * Clear all app data from localStorage
 */
export function clearAllStorage(): void {
  try {
    const keys = Object.keys(localStorage)
    keys.forEach((key) => {
      if (key.startsWith(STORAGE_PREFIX)) {
        localStorage.removeItem(key)
      }
    })
  } catch (error) {
    console.error('Error clearing localStorage:', error)
  }
}

/**
 * Check if localStorage is available
 */
export function isStorageAvailable(): boolean {
  try {
    const testKey = '__storage_test__'
    localStorage.setItem(testKey, 'test')
    localStorage.removeItem(testKey)
    return true
  } catch {
    return false
  }
}

// Storage keys
export const STORAGE_KEYS = {
  CART: 'cart',
  CUSTOMER_INFO: 'customer-info',
  VERIFIED_EMAIL: 'verified-email',
  ORDER_PREFERENCES: 'order-preferences',
  RECENT_ORDERS: 'recent-orders',
} as const
